import { render, staticRenderFns } from "./Versionering.vue?vue&type=template&id=61a527f3&scoped=true"
import script from "./Versionering.vue?vue&type=script&lang=js"
export * from "./Versionering.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a527f3",
  null
  
)

export default component.exports